export { CoverWidget } from './CoverWidget'
